import { render } from "./AlternateContactCard.vue?vue&type=template&id=1a6e7a77"
import script from "./AlternateContactCard.vue?vue&type=script&lang=js"
export * from "./AlternateContactCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__